import { OpenFeature } from '@openfeature/react-sdk';

import { FEATURE_FLAG_DOMAIN } from '@heidi/runtime/feature-flags';

export const DESKTOP_LOGOUT_WAIT_FOR_UPLOADS_FLAG_KEY =
  'release-desktop-logout-wait-for-uploads';

export const isDesktopLogoutWaitForUploadsEnabled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    DESKTOP_LOGOUT_WAIT_FOR_UPLOADS_FLAG_KEY,
    false
  );
